import { useEffect } from "react";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";

import "./App.css";
import "./layout.css";

import Footer from "./components/Footer";
import Header from "./components/Header";

import Download from "./pages/Download";
import { Gifts } from "./pages/Gifts/index.tsx";
import { PaymentStatus } from "./pages/PaymentStatus";
import Terms from "./pages/Terms";

const YM_ID = 108472115;

function App() {
  const location = useLocation();

  useEffect(() => {
    if (typeof ym !== "undefined") {
      ym(YM_ID, "hit", window.location.href);
    }
  }, [location]);

  return (
    <div className="layout-wrapper">
      <header>
        <Header />
      </header>

      <main>
        <Routes>
          <Route path="/gifts" element={<Gifts />} />
          <Route path="/payment-status" element={<PaymentStatus />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="*" element={<Navigate to="/install" replace />} />
          <Route path="/install" element={<Download />} />
        </Routes>
      </main>

      <footer>
        <Footer />
      </footer>
    </div>
  );
}

export default App;
